import React from 'react';
import { Button } from '@sato/components';

import { Link } from '@components/common/Link';
import { getLinkIcon, isInternalPath } from '@utils/link.utils';

import { ILinkButton, ParsedEntry } from '../types';
import { linkButtonVariantMap } from '../utils/entry.utils';

export const ContentfulLinkButton = ({
  className,
  id,
  text,
  url,
  variant,
  icon,
  linkParams,
  iconPosition,
}: ParsedEntry<ILinkButton> & { className?: string }) => {
  const params = new URLSearchParams(window.location.search);

  // resolve linkButton only if it's translated in the current language
  if (!url && !text) return null;

  /*
   * Add dynamic link params to URL, such as a contact
   * identifier for the customer segmentation questionnaire
   */
  const formatUrl = () => {
    if (!url || !linkParams) return url;

    const urlObj = new URL(
      url,
      isInternalPath(url) ? window.location.origin : undefined
    );

    linkParams.forEach((linkParam) => {
      const param = params.get(linkParam);

      if (!param) return;

      urlObj.searchParams.set(linkParam, param);
    });

    return urlObj.toString();
  };

  return (
    <Button
      id={id}
      wrapperComponent={Link}
      to={formatUrl()}
      variant={linkButtonVariantMap[variant ?? 'no variant']}
      {...((icon?.icon || variant === 'text') && {
        icon: icon?.icon ?? getLinkIcon(url),
        iconPosition: iconPosition ?? (icon?.icon ? 'left' : 'right'),
      })}
      className={className}
    >
      {text}
    </Button>
  );
};
